import request from '@/utils/request'
//显示文件目录
export function showFolder(data) {
    return request({
        url: '/libray/show_folder',
        method: 'get',
        params: data
    })
}
//获取图片库空间
export function getInfo(data) {
    return request({
        url: '/libray/img_info',
        method: 'get',
        params: data
    })
}
//获取所有图片
export function showImgList(data) {
    return request({
        url: '/libray/show_img_list',
        method: 'get',
        params: data
    })
}
//创建或修改目录
export function createFolder(data) {
    return request({
        url: '/libray/create_folder',
        method: 'post',
        data
    })
}
//删除文件目录
export function delFolder(data) {
    return request({
        url: '/libray/del_folder',
        method: 'post',
        data
    })
}
//删除图片
export function delImg(data) {
    return request({
        url: '/libray/delete_img',
        method: 'post',
        data
    })
}